import { render, staticRenderFns } from "./VCardActions.vue?vue&type=template&id=cc1f786e&"
import script from "./VCardActions.vue?vue&type=script&lang=js&"
export * from "./VCardActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports